'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const UserIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="UserIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_278_9916)">
          <g clipPath="url(#clip1_278_9916)">
            <path
              d="M0.5 23C0.547921 21.5929 0.888491 20.2112 1.5 18.943C2.205 17.533 5.15 16.556 8.847 15.187C9.847 14.816 9.683 12.206 9.24 11.719C8.2 10.576 7.32 9.235 7.32 6C7.32 2.735 9.45 1 12 1C14.55 1 16.68 2.735 16.68 6C16.68 9.235 15.799 10.576 14.76 11.719C14.317 12.206 14.153 14.819 15.153 15.187C18.853 16.556 21.795 17.533 22.5 18.943C23.1115 20.2112 23.4521 21.5929 23.5 23H0.5Z"
              stroke={sx?.color || '#3D517B8F'}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  )
}

UserIcon.propTypes = {
  sx: PropTypes.object
}
